import _includes from 'lodash/includes';
import { gqlCountryEnum as COUNTRY } from '@minecraft.graphql-types';
import { countryUnit } from '@minecraft.utils';

type UseMeasurementUnitTypeResult = {
  showInImperial: boolean;
};

const useMeasurementUnitType = (accountCountryCode: string | typeof COUNTRY): UseMeasurementUnitTypeResult => {
  const shouldShowInImperial = (): boolean => {
    let showInImperial = false;
    let showInMetric = false;

    if (accountCountryCode) {
      showInImperial = _includes(countryUnit.COUNTRIES_WITH_IMPERIAL_UNITS, accountCountryCode);
      showInMetric = _includes(countryUnit.COUNTRIES_WITH_METRIC_UNITS, accountCountryCode);
    }

    // if no account country in white list of countries then the default measurement type is imperial
    if (!showInImperial && !showInMetric) {
      return true;
    }

    return showInImperial;
  };

  return {
    showInImperial: shouldShowInImperial(),
  };
};

export default useMeasurementUnitType;
